import {useMutation} from '@tanstack/react-query';

import {
  RQ_GENERATE_OTP_EMAIL,
  RQ_GENERATE_OTP_MOBILE,
  RQ_VERIFY_OTP_EMAIL,
  RQ_VERIFY_OTP_MOBILE,
} from './constants/verifyUserConstant';
import {rqCreateRequest} from './rqHttpUtils';

export const RQGenerateOtpEmail = (options = {}) => {
  return useMutation({
    mutationKey: ['rq_generate_otp_email'],
    mutationFn: async email => {
      return rqCreateRequest(
        RQ_GENERATE_OTP_EMAIL,
        null,     
        null,
        {email},  
        null,
      );
    },
    ...options,
  });
};

export const RQGenerateOtpMobile = (options = {}) => {
  return useMutation({
    mutationKey: ['rq_generate_otp_mobile'],
    mutationFn: async mobile => {
      if (!mobile) {throw new Error('Mobile number is required');}

      return rqCreateRequest(
        RQ_GENERATE_OTP_MOBILE,
        null,
        null,
        {phoneNumber: String(mobile)}, 
        null,
      );
    },
    ...options,
  });
};

export const RQVerifyOtpMobile = (options = {}) => {
  return useMutation({
    mutationKey: ['rq_verify_otp_mobile'],
    mutationFn: async ({mobile, otp}) => {
      return rqCreateRequest(
        RQ_VERIFY_OTP_MOBILE,
        null,
        null,
        {phoneNumber: String(mobile), otp: String(otp)},
        null,
      );
    },
    ...options,
  });
};
export const RQVerifyOtpEmail = (options = {}) => {
  return useMutation({
    mutationKey: ['rq_verify_otp_email'],
    mutationFn: async ({email, otp}) => {
      return rqCreateRequest(
        RQ_VERIFY_OTP_EMAIL,
        null,      
        null,      
        null,      
        null,      
        undefined, 
        undefined, 
        {          
          email: String(email),
          otp: String(otp),
        },
      );
    },
    ...options,
  });
};
